<template>
  <div class="controls">
    <a :href="medium.link" target="_blank" rel="noopener noreferrer" class="button" ref="link">
      <div class="dashicons dashicons-admin-links" />
    </a>
  </div>
</template>

<script>
export default {
  data: () => ({
    shown: false
  }),
  props: {
    medium: Object
  },
  methods: {
    toggle() {
      this.$refs.link.click()
    }
  }
} 
</script>

<style>

</style>